import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Me, Role } from '../../../../redux/Auth/auth.selectors';
import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags } from '../../../../redux/DefaultModelActions';
import { APIBase, APIGet } from '../../../../services/API';
import { FullPermissions } from './permissions.selectors';

const model = 'Permission';
const route = '/v1/permission';

export const searchPermissions = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const searchMyPermissions = (page, limit, search, view, args) => searchModels(model, '/v1/my/permission', page, limit, search, view, args);
export const createPermission = (args) => createModel(model, route, args);
export const updatePermission = (id, args) => updateModel(model, route, id, args);
export const deletePermission = (id) => deleteModel(model, route, id);
export const restorePermission = (id) => restoreModel(model, route, id);
export const getPermission = (id) => getModel(model, route, id);
export const getPermissionRevision = (id) => getRevisions(model, route, id);
export const duplicatePermission = (id) => duplicateModel(model, route, id);

export const loadPermission = async (id) => {

    try {
        const res = await APIGet(`${APIBase}${route}/${id}`)
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}

export const useMyPermissions = () => {

    const store = FullPermissions();
    const dispatch = useDispatch();
    const me = Me();
    const currentUserRole = Role();
    const [checking, setChecking] = useState('notchecked');


    useEffect(() => {
        if (!me) return;

        // Get All Permissions for the current user
        const args = {}
        args.prefix = 'mypermissions';
        args.UserId = `[${me.id}]`;

        // Get Permissions if we don't have them already.
        if (!store?.mypermissions?.rows) dispatch(searchMyPermissions(0, 999, null, null, args))



    }, [me])

    const getFiltersBasedOnMyPermission = (model) => {

        // Don't Filter Anything for Admins or Owners
        if (currentUserRole === 'owner' || currentUserRole === 'admin') return null;

        const p = store?.mypermissions?.rows?.filter(p => {
            if (p.modelType === model) return p.modelId;
            else return null;
        });

        if (!p) return null;
        if (p?.length <= 0) return null;
        const a = p.map(i => '"' + i.modelId + '"');
        const str = a.join(',');
        return `[${str}]`;

    }

    const hasPermission = (model, id) => {

        if (currentUserRole === 'owner' || currentUserRole === 'admin') {
            setChecking('checked');
            return true;
        }
        if (!store?.mypermissions?.rows) return false;
        setChecking('checked');
        const p = store?.mypermissions?.rows?.find(i => (i.modelType === model && i.modelId === id));
        return (p) ? true : false;
    }

    const getPermissionRole = (model, id) => {
        if (currentUserRole === 'owner' || currentUserRole === 'admin') return currentUserRole;
        if (!store?.mypermissions?.rows) return false;
        const p = store?.mypermissions?.rows?.find(i => (i.modelType === model && i.modelId === id));
        return (p) ? p.role : false;
    }

    return {
        permissions: store?.mypermissions?.rows,
        getFiltersBasedOnMyPermission,
        hasPermission,
        getPermissionRole,
        permissionChecked: checking,
        setChecking
    }
}